export default function hashString(string) {
    const stringUint8 = new TextEncoder().encode(string);
    return crypto.subtle.digest('SHA-256', stringUint8).then((hashBuffer) => {
        const hashArray = Array.from(new Uint8Array(hashBuffer));
        const hashHex = hashArray
            .map(bytes => bytes.toString(16).padStart(2, '0'))
            .join('');
        return hashHex;
    });
}
